<script setup lang="ts">
import type { GridColumnProps } from '@progress/kendo-vue-grid'
import { formatCurrency } from '@/lib/format.ts'
import { formatDate } from '@/lib/utils.ts'
import CardTableContent from '@/components/ui/card/CardTableContent.vue'
import Card from './ui/card/Card.vue'
import baseRepository from "@/repository/BaseRepository.ts";

const columns = [
  { field: 'proposition_title', title: 'Proposition' },
  { field: 'agence_title', title: 'Agence' },
  { field: 'date', title: 'Date' },
  { field: 'montant_facturer', title: 'Montant proposition' },
  { field: 'montant_encaisser', title: 'Montant facturé' },
  { field: 'montant_en_attente', title: 'Montant reste dû' },
  { field: 'etat', title: 'État' },
] as GridColumnProps[]

const formatCell = (field: string, value: string) => {
  if (['montant_facturer', 'montant_encaisser', 'montant_en_attente'].includes(field)) {
    return formatCurrency(value as unknown as number)
  }
  if (field === 'date') {
    return formatDate(value)
  }
  return value
}

const getData = async (
  skip: number,
  take: number,
  sortField: string,
  sortOrder: 'asc' | 'desc',
) => {
  const response = await baseRepository.getPropositionsTableData(
    skip,
    take,
    sortField,
    sortOrder,
  )
  return {
    data: response.data,
    total: response.total,
  }
}
</script>

<template>
  <Card title="Détail des propositions" :download-excel="baseRepository.downloadPropositionExcel">
    <CardTableContent
      :columns="columns"
      :get-data="getData"
      :format-cell="formatCell"
      :initial-sort="{ field: 'proposition_id', dir: 'asc' }"
    />
  </Card>
</template>
